// covered-by: frontends/carrie/src/ask-v2/home/__tests__/AskV2Home.test.tsx
import { useTranslation } from "react-i18next";

import { SlidingSegmentedControl } from "../../components/SlidingSegmentedControl";

export type AskV2ComposerMode = "chat" | "project";

export function AskV2ComposerModeToggle({
  value,
  onChange,
  "data-testid": dataTestId = "ask-v2-composer-mode",
}: {
  value: AskV2ComposerMode;
  onChange: (mode: AskV2ComposerMode) => void;
  "data-testid"?: string;
}) {
  const { t } = useTranslation("ui");

  return (
    <SlidingSegmentedControl
      value={value}
      onChange={onChange}
      ariaLabel={t("home.composerModeAriaLabel")}
      data-testid={dataTestId}
      thumbTestId="ask-v2-composer-mode-thumb"
      items={[
        {
          id: "chat",
          testId: "ask-v2-mode-chat",
          content: t("home.composerModeChat"),
        },
        {
          id: "project",
          testId: "ask-v2-mode-project",
          content: t("home.composerModeProject"),
        },
      ]}
    />
  );
}
